import React from 'react';
import {Image} from 'antd-mobile';
import {useTranslation} from 'react-i18next';
import HomeBottomCard from '@/components/business/home-bottom-card/home-bottom-card';
import pay1 from '@assets/imgs/home/pay/bkash.png';
const pay2 = require('@assets/imgs/home/pay/ju.png');

const HomePays = () => {
  const {t} = useTranslation();
  const imgs = [pay1, pay2, ''];
  return (
    <HomeBottomCard
      title={t('home.label.pays')}
      cols={3}
      imgs={imgs}
      renderItem={url =>
        url ? (
          <div className="h-[2.625rem]">
            <Image src={url} height={'2.625rem'} />
          </div>
        ) : (
          <div className="h-[2.625rem] w-[5rem]" />
        )
      }
      px={'px-3'}
    />
  );
};

export default HomePays;
